import { translate } from '~l10n/client';

import { toast } from '~shared/components/Toast';

import { QuizToastActions } from '.';

export const handleToastError = (
  action: QuizToastActions,
  error: Error | unknown
) => {
  switch (action) {
    case QuizToastActions.DELETE: {
      return toast(translate('An error occurred while trying to delete'), {
        tone: 'critical',
      });
    }
    case QuizToastActions.PURGE: {
      return toast(
        translate('An error occurred while trying to permanently delete'),
        {
          tone: 'critical',
        }
      );
    }
    case QuizToastActions.MERGE: {
      return toast(
        translate('An error occurred while trying to merge quizzes'),
        {
          tone: 'critical',
        }
      );
    }
    case QuizToastActions.RESTORE: {
      return toast(translate('An error occurred while trying to restore'), {
        tone: 'critical',
      });
    }
    case QuizToastActions.RENAME: {
      return toast(
        translate('An error occurred while trying to rename the folder'),
        {
          tone: 'critical',
        }
      );
    }
    case QuizToastActions.CREATE_FOLDER: {
      return toast(
        translate('An error occurred while trying to create a folder'),
        {
          tone: 'critical',
        }
      );
    }
    case QuizToastActions.CREATE_QUIZ: {
      return toast(
        translate('An error occurred while trying to create a quiz'),
        {
          tone: 'critical',
        }
      );
    }
    case QuizToastActions.COPY: {
      return toast(translate('An error occurred while trying to duplicate'), {
        tone: 'critical',
      });
    }
    case QuizToastActions.IMPORT: {
      return toast(
        translate(
          "Failed to import quiz because it doesn't exist or you don't have permission to import it" /* eslint-disable-line */ /* prettier-ignore */
        ),
        {
          tone: 'critical',
        }
      );
    }
    default: {
      return toast(`Error: ${(error as unknown as Error).message}`, {
        tone: 'critical',
      });
    }
  }
};
